import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FaApple } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import styles from './SSOLoginButton.module.less';
import { Button } from '$HVUI';
export const SSOLoginButton = () => {
    const getNextUrl = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const nextParam = urlParams.get('next');
        return nextParam ? `?next=${nextParam}` : '';
    };
    return (_jsx("div", { className: styles['container'], children: _jsx(Button, { color: "ocean-dk", className: styles['sso-button'], id: "sso-login-button", level: "secondary", onClick: () => (window.location.href = `/oidc/login/${getNextUrl()}`), text: "Sign in with", icon: _jsx("span", { className: styles['icon-row'], children: _jsxs("span", { className: styles['icon-group'], children: [_jsx(FaApple, { className: styles['sso-icon'] }), _jsx(FcGoogle, { className: styles['sso-icon'] })] }) }) }) }));
};
